import { View } from '../components/view'
import { Defaults } from 'es-decorators'
import { reduxStore } from 'init/redux-store'

/**
 * Вызов редьюсеров для связи с react-redux.
 * @param {Object} reduxStore Ссылка на store.
 * @param {string} jsView Идентификатор текущей страницы.
 */
@Defaults({
  /** @inheritDoc */
  additionalOptions: ['jsView'],
})
export class ReduxDispatchesView extends View {
  /** @inheritDoc */
  run () {
    this.listenTo(this.settlement, 'sync', this._onSettlementChange)
  }

  /**
   * Вызов редьюсера в store.
   * @param {string} type Тип редьюсера.
   * @param {Object} data Данные для редьюсера.
   */
  dispatch (type, data) {
    reduxStore.dispatch({ type: type, ...data })
  }

  /**
   * Вызов редьюсера после обновления формы поселения
   * в зависимости от текущей страницы.
   * @private
   */
  _onSettlementChange () {
    if (reduxStore) {
      switch (this.jsView) {
        case 'joint-purchase-control':
          this._updateMinOrderSum(this.settlement.get('min_order_sum'))
          break
        case 'reactive-checkout':
          this._updateCurrentSettlement(this.settlement.toJSON())
      }
    }
  }

  /**
   * Изменяем минимальную сумму заказа в redux store
   * @param {number} minsum Минимальная сумма заказа.
   * @private
   */
  _updateMinOrderSum (minsum) {
    this.dispatch(
      'USER_UPDATE_DATA',
      { data: {
        min_order_sum: minsum,
      },
      })
  }

  /**
   * Устанавливаем город в redux store.
   * @param {Object} settlement Объект с данными города.
   * @private
   */
  _updateCurrentSettlement (settlement = {}) {
    this.dispatch(
      'settlement/SETTLEMENT_IS_SAVED',
      { id: settlement.settlement_id }
    )
  }
}
